module.exports = __webpack_public_path__ + "img/mob-primary.0ea7732d.svg";